import React, { FC } from 'react'
import MenuWidget from "../../../../../components/Widget/MenuWidget";
import { useLang } from "../../../../../hooks/useLang";
import './Footer.style.scss';
import { Button, Col, Row, Tooltip } from 'antd';
import AppImage from '../../../../../components/Image/AppImage';
import { ReactComponent as FacebookIcon } from '../../../../../assets/images/svg/Facebook.svg';
import { ReactComponent as TwitterIcon } from '../../../../../assets/images/svg/Twitter.svg';
import { ReactComponent as LinkedInIcon } from '../../../../../assets/images/svg/LinkedIn.svg';
import { NavLink } from 'react-router-dom';
import { ArrowUpOutlined } from "@ant-design/icons";

const Footer: FC<any> = props => {
    const { t } = useLang();
    const backToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    return (
        <>
            <div className="position-relative mt-5">
                <Button onClick={backToTop} className="back-top">
                    <ArrowUpOutlined />
                </Button>
                <svg width="100%" viewBox="0 0 1366 41" fill="none" style={{ marginBottom: '-10px' }} xmlns="http://www.w3.org/2000/svg">
                    <path d="M682.5 0.500074C554.5 40.5 214 10.5 -0.5 10.5V40.5H1366.5V10.5C1149.5 10.5 811 40.4999 682.5 0.500074Z" fill="#245473" />
                </svg>
            </div>
            <footer className="site-footer">
                <div className="container-fluid py-3">
                    <Row gutter={[16, 16]}>
                        <Col span={8} xs={24} sm={24} md={24} lg={6} className="text-center text-lg-start">
                            <strong style={{ fontSize: '18px' }}>&copy; Copyright 2020-2022</strong><br />
                            Ministry of Science &amp; Technology<br />
                            All rights reserved
                        </Col>
                        <Col span={16} xs={24} sm={24} md={24} lg={18}>
                            <div className="bg-white text-dark p-3 footer-credit text-center text-md-start">
                                <Row gutter={[16, 16]}>
                                    <Col span={8} xs={24} sm={24} md={8}>
                                        <div className="footer-credit-item">
                                            {/* For visual only, not for screen readers/search engines | for desktops */}
                                            <strong className="d-none d-xl-inline-block" aria-hidden="true" dangerouslySetInnerHTML={{ __html: t('Planned &<br/> Implemented by') }}></strong>
                                            {/* For search engines/screen readers | for mobiles */}
                                            <span className="d-xl-none"><strong>{t('Planned & Implemented by')}</strong><br /></span>
                                            <span className="d-inline-block" style={{ width: '160px', verticalAlign: 'bottom' }}>
                                                <a className="footer-most-logo text-dark" href="https://most.gov.bd/" target="_blank" rel="noopener noreferrer nofollow">
                                                    <AppImage imageServer='LOCAL' width='45' height='45' src="logo/logo-login.png" alt="Logo of the Government of the Peoples Republic of Bangaldesh" className="" />
                                                    <span className="ms-1 text-start" style={{ fontSize: '12px' }} dangerouslySetInnerHTML={{ __html: t('Ministry of Science &<br/>Technology') }}></span>
                                                </a>
                                            </span>
                                        </div>
                                    </Col>
                                    <Col span={8} xs={24} sm={24} md={8}>
                                        <div className="footer-credit-item">
                                            {/* For visual only, not for screen readers/search engines | for desktops */}
                                            <strong className="d-none d-xl-inline-block" aria-hidden="true" dangerouslySetInnerHTML={{ __html: t('Technical <br/>Support') }}></strong>
                                            {/* For search engines/screen readers | for mobiles */}
                                            <span className="d-xl-none"><strong>{t('Technical Support')}</strong><br /></span>
                                            <span className="d-inline-block" style={{ verticalAlign: 'bottom' }}>
                                                <Tooltip title={t('Access to Information (a2i)')}>
                                                    <a href="https://a2i.gov.bd/" target="_blank" rel="noopener noreferrer nofollow">
                                                        <AppImage imageServer='LOCAL' width='40' height="42" src="logo/a2i.png" alt="Logo of Access to Information (a2i)" className="ms-xl-3 me-3" />
                                                    </a>
                                                </Tooltip>
                                                <a href="https://ictd.gov.bd/" target="_blank" rel="noopener noreferrer nofollow">
                                                    <AppImage imageServer='LOCAL' width='80' height="43" src="logo/ict-division.png" alt="Logo of ICT Division, Bangladesh" className="" />
                                                </a>
                                            </span>
                                        </div>
                                    </Col>
                                    <Col span={8} xs={24} sm={24} md={8}>
                                        <div className="footer-credit-item">
                                            {/* For visual only, not for screen readers/search engines | for desktops */}
                                            <strong className="d-none d-xl-inline-block" aria-hidden="true" dangerouslySetInnerHTML={{ __html: t('Designed & <br/>Developed by') }}></strong>
                                            {/* For search engines/screen readers | for mobiles */}
                                            <span className="d-xl-none"><strong>{t('Designed & Developed by')}</strong><br /></span>
                                            <span className="d-inline-block ms-xl-3" style={{ verticalAlign: 'bottom' }}>
                                                <Tooltip title={t('TechnoVista Limited - a Mohammadi Group Company')}>
                                                    <a href="https://technovista.com.bd?ref=most" target="_blank" rel="noopener noreferrer">
                                                        <AppImage imageServer='LOCAL' width='100' height="46" src="logo/TechnoVista.png" alt="Logo of TechnoVista Limited - a Mohammadi Group Company" className="" />
                                                    </a>
                                                </Tooltip>
                                            </span>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>

                    <div className="footer-bottom pt-4">
                        <Row gutter={[16, 16]}>
                            <Col span={8} xs={24} sm={8} className="text-center text-sm-start">
                                <span>
                                    <NavLink to="https://facebook.com/pg/pagename" target="_blank" rel="noopener noreferrer" className="text-white me-3">
                                        <Tooltip title={t('Facebook')}>
                                            <FacebookIcon style={{ height: '21px', fill: '#fff' }} />
                                            <span className="visually-hidden">{t('Facebook')}</span>
                                        </Tooltip>
                                    </NavLink>
                                    <NavLink to="https://facebook.com/pg/pagename" target="_blank" rel="noopener noreferrer" className="text-white me-3">
                                        <Tooltip title={t('Twitter')}>
                                            <TwitterIcon style={{ height: '21px', fill: '#fff' }} />
                                            <span className="visually-hidden">{t('Twitter')}</span>
                                        </Tooltip>
                                    </NavLink>
                                    <NavLink to="https://facebook.com/pg/pagename" target="_blank" rel="noopener noreferrer" className="text-white">
                                        <Tooltip title={t('LinkedIn')}>
                                            <LinkedInIcon style={{ height: '21px', fill: '#fff' }} />
                                            <span className="visually-hidden">{t('LinkedIn')}</span>
                                        </Tooltip>
                                    </NavLink>
                                </span>
                                <span className="follow-us text-uppercase d-none d-md-inline-block">{t('Follow us')}</span>
                            </Col>
                            <Col span={16} xs={24} sm={16}>
                                <nav className="footer-nav text-center text-md-end">
                                    <MenuWidget parentId={6} />
                                </nav>
                            </Col>
                        </Row>
                    </div>
                </div>
            </footer>
        </>
    );
}

export default React.memo(Footer);
